import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseLedgerSearch } from "@/features/money";
import { LedgerPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/ledger")({
  validateSearch: strictSearch(parseLedgerSearch),
  component: Ledger,
});

function Ledger() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <LedgerPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
      hrefOfKind={(kind) => router.buildLocation({ to: "/money/ledger", search: { kind } }).href}
    />
  );
}
